import React, { useEffect, useState } from 'react'
import { Link,useNavigate } from "react-router-dom"
import { ShoppingBag } from "react-feather"
import clsx from "clsx"
import { dummyOrders } from '@/dummydata'
import OrderItem from "@/components/OrderItem"
import PageHeader from "@/components/PageHeader"
import Button from "@/components/Button"
import api from '../api'
import PaymentStatus from '../components/PaymentStatus'
import { getPaymentGatewayId } from '../reducers/utils'
import { useGlobalData } from '../context/globalContext'

export default function OrdersPage() {
	// const [orders, setOrders] = useState([...dummyOrders])
	const [orders, setOrders] = useState([])
	const [open, setOpen] = useState(false);
	const [statusData, setStatusData] = useState(null);
	const navigate = useNavigate()
	const  websiteDetails  = useGlobalData();
	const webDetails = websiteDetails.websiteDetails

	useEffect(() => {
		(async () => {
			const resp = await api.fetchAllOrders()
			// console.log("orders",resp)
			if (resp.length) {
				setOrders(resp)
			}
		})()
	}, [])


		const handlePaymentStatus = async (order) => {
		if (order.paymentMethod === "cod") {
        setStatusData({
          order_id: order.order_id,
          payment_orderId: order.payment_orderId,
          status: "COD",
          currency: "INR",
          amount: order.amount,
          total: order.amount,
          orderDate: order.orderDate || new Date(),
          paymentType: "COD",
          paymentMethod: "Cash on Delivery",
          txn_uuid: "Not Available",
          txnDate: new Date(order.createdAt).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
          }),
        });
          setOpen(true);
       }else{
		try {
			const res = await api.razorpayPaymentStatus(order.txn_uuid,order.txn_orderId,order._id,order.amount,getPaymentGatewayId(webDetails?.pg_gateways))
			const data = await res.data;
         if(order.amount == data.amount/100){
       setStatusData({
            order_id: order.order_id,
            payment_orderId: data.order_id,
            status: data.status || "Unknown",
            currency: data.currency || "INR",
            amount: data.amount/100,
            total: order.amount,
            orderDate: order.orderDate || new Date(),
            orderStatus: data.orderStatus || "N/A",
            paymentType: data.method || order.paymentMehod,
            paymentMethod: data.paymentMethod || "N/A",
            txn_uuid: data.id || "Not Available",
            txnDate:new Date(data.created_at * 1000).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }) || order.orderDate,
          });
        }else{
           setStatusData({
            order_id: order.order_id,
            payment_orderId: order.payment_orderId,
            status: "Failed(Amount Mismatched)",
            currency: data.currency || "INR",
            amount: data.amount,
            total: order.amount,
            orderDate: order.orderDate || new Date(),
            orderStatus: data.orderStatus || "N/A",
            paymentType: data.paymentType || order.paymentMethod,
            paymentMethod: data.paymentMethod || "N/A",
             txn_uuid: data.id || "Not Available",
            txnDate:new Date(data.created_at * 1000).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }) || order.orderDate,
          });
        }
         setOpen(true);
		} catch (error) {
			 console.error("Error fetching payment status:", error);

          setStatusData({
            order_id: order.order_id,
            status: "Payment not done",
            currency: "INR",
            amount: order.amount,
            total: order.amount,
            orderDate: order.orderDate || new Date(),
            paymentType: order.paymentType,
            paymentMethod: order.paymentMethod,
            txn_uuid: "N/A",
             txnDate: new Date().toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
          }),
          });
           setOpen(true);
		   }
         }
	}

	if (orders.length === 0) {
		return (
			<main className="min-h-screen flex flex-col items-center text-center my-14 p-4 space-y-4">
				<PageHeader>You Currently Have No Orders</PageHeader>
				<Link to="/products">
					<Button link className="text-xl">
						<ShoppingBag className="mr-2" />
						Order Something
					</Button>
				</Link>
			</main>
		)
	}
	
	return (
		<main className="min-h-screen my-14">
			<PageHeader>Your Orders</PageHeader>

			<section className={clsx(
				"flex flex-col max-w-2xl",
				"border border-gray-300 rounded", 
				"shadow divide-y divide-gray-200",
				"my-16 px-2 py-4 m-4",
				"sm:mx-auto",
			)}>
				{/* {orders.map(order => (
					<Link key={order._id} to={`/orders/${order._id}`}>
						<OrderItem
							products={order.products}
							status={order.status}
							amount={order.amount}
							// paymentStatus={() => handlePaymentStatus(order)}
						/>

						<div className='text-center'>
									<Button 
									  type="button" 
									  className="mt-2"
									   onClick={()=>handlePaymentStatus(order)}
									  >
						Payment Status
						</Button>
						</div>
					</Link>
				))} */}



				{orders.map(order => (
					<div
						key={order._id}
						// className="border border-gray-300 rounded shadow-sm my-4"
					>
						<OrderItem
						orderId={order.order_id}
						products={order.products}
						status={order.status}
						amount={order.amount}
						/>

						<div className="flex justify-center gap-4 pb-4">
						<Button
							type="button"
							onClick={() => handlePaymentStatus(order)}
						>
							Payment Status
						</Button>

						<Button
							type="button"
							variant="outline"
							onClick={() => navigate(`/orders/${order.order_id}`)}
						>
							Order Details
						</Button>
						</div>
					</div>
					))}
			</section>

			{open&&(
				<PaymentStatus
				statusData={statusData}
				open={() => setOpen(false)}>
				</PaymentStatus>
			)}
		</main>
	)
}